import { render } from "./App.vue?vue&type=template&id=25207a56"
const script = {}

import "./App.vue?vue&type=style&index=0&id=25207a56&lang=less"

import exportComponent from "/data/jenkins/workspace/ecom_ecom-offical-website_node_sharelib_cicd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__